module.exports = __webpack_public_path__ + "static/media/logo.9991e063.svg";